import { render, staticRenderFns } from "./CarrierIncidentEditModal.vue?vue&type=template&id=18beb404&scoped=true&"
import script from "./CarrierIncidentEditModal.vue?vue&type=script&lang=js&"
export * from "./CarrierIncidentEditModal.vue?vue&type=script&lang=js&"
import style0 from "./CarrierIncidentEditModal.vue?vue&type=style&index=0&id=18beb404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18beb404",
  null
  
)

export default component.exports